<template>
    <footer class="footer" style="width: 100%; font-size: 0.75rem;">
        <div class="container text-center">
            ポケットモンスター・ポケモン・Pokémonは<a class="link" href="https://www.nintendo.co.jp/" target="_blank" rel="noopener noreferrer">任天堂</a>・<a class="link" href="http://www.creatures.co.jp/" target="_blank" rel="noopener noreferrer">クリーチャーズ</a>・<a class="link" href="http://www.gamefreak.co.jp/" target="_blank" rel="noopener noreferrer">ゲームフリーク</a>の登録商標です。<br>
            当サイトは一ポケモンファンが個人で作成・管理しているWebアプリケーションです。
            当サイトではポケモンの画像等のデータを<a class="link" href="https://pokeapi.co/" target="_blank" rel="noopener noreferrer">PokeAPI</a>より取得・使用しています。<br>
            当サイト独自のイラストやソースコード等についての著作権は<a class="link" href="https://twitter.com/algo05_pokemon" target="_blank" rel="noopener noreferrer">制作者 兼 管理人 (Algo05)</a> が保有しています。
        </div>
    </footer>
</template>

<style scoped>
.footer {
    background-color: #ffa534;
    color: white;
}
.link {
    color: white;
}
.link:hover {
    color: red;
}
</style>